/*
 * @Author: your name
 * @Date: 2020-10-09 10:28:02
 * @LastEditTime: 2020-10-09 10:39:39
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/utils/login.js
 */
import { Local } from './local.js';
import { CheckGlobalLogin } from '../services/login';
const currentDomain = window.location.host.indexOf('localhost') == -1 ? window.location.origin : 'http://ryyzs.dev-s.yunduoketang.cn';
import history from '@/router/history'; //用户登录方法（需要判断是否关闭了独立登陆页，useLoginPage表示是否使用登录页面：0否，1是）

export async function goLogin(type = "login", btnType) {
  // btnType 有值代表头部
  console.log(`此时类型为${type},此时是否是头部按钮${btnType}`);
  let useLoginPage = parseInt(Local.get('useLoginPage'));
  console.log(`此时返回值为`, useLoginPage);
  let btnStatus = await CheckGlobalLogin();
  console.log(`此时返回值为`, useLoginPage, btnStatus.data.data);
  let data = btnStatus.data.data;
  let openFlag = null;
  let thirdLoginUrl = null;

  if (typeof data === 'boolean') {
    openFlag = data;
  } else {
    openFlag = data.openFlag;
    thirdLoginUrl = data.thirdLoginUrl;
  }

  if (useLoginPage && openFlag) {
    console.log(`需全部跳转独立页`);

    if (thirdLoginUrl) {
      let index = thirdLoginUrl.indexOf('http') + thirdLoginUrl.indexOf('//');
      window.location.href = index > -2 ? `${thirdLoginUrl}` : `//${thirdLoginUrl}`;
    } else {
      jumpLoginUrl(type); // 全部跳转页面
    }

    return;
  }

  if (useLoginPage && !openFlag && btnType) {
    console.log(`仅有头部跳转独立页`);
    jumpLoginUrl(type); // 仅有头部跳转页面

    return;
  }

  console.log(`全部为弹层`);
  operatingLayer(type); // 全部不跳转页面
}

function operatingLayer(type) {
  document.getElementById('loginRegisterBox').style.display = 'flex';
  document.getElementsByClassName('register-box')[0].style.display = type === 'login' ? 'none' : 'block';
  document.getElementsByClassName('login-box')[0].style.display = type === 'login' ? 'block' : 'none';
  document.getElementsByClassName('header-active')[type === 'login' ? 0 : 1].classList.add('active');
  document.getElementsByClassName('header-active')[type === 'login' ? 1 : 0].classList.remove('active');
}

function jumpLoginUrl(type) {
  let hash = '';

  if (window.location.hash.indexOf('?code=') > -1) {
    hash = `${window.location.pathname}${window.location.hash.split('?')[0]}`;
  } else {
    hash = `${window.location.pathname}${window.location.hash}`;
  }

  let queryString = window.encodeURIComponent(hash);
  history.push(`/join/${type}?backUrl=${queryString}`); // window.location.href = `${currentDomain}/s/pc/#/join/${type}`
}